import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toHttpPararms } from './to-http-params';
import { PagedResultModel } from '../common';
import { HttpRequestOptions } from './http-request-options';
import { MmSpinningService } from '../spin';
import { NzMessageService } from 'ng-zorro-antd/message';
import { tap, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { httpConstants } from './http-constants';
import { httpI18nKeys } from './http-i18n-keys';
import { MmHttpClient } from './http-client.service';
import { HttpTranslations } from './http-translations';

export class EntityApiClient<TModel, TQueryModel> {

    constructor(
        protected injector: Injector,
        protected entityName: string) {

    }

    protected get httpClient() {
        return this.injector.get(MmHttpClient);
    }

    protected get spinningService() {
        return this.injector.get(MmSpinningService);
    }

    protected get messageService() {
        return this.injector.get(NzMessageService);
    }

    protected get translateService() {
        return this.injector.get(TranslateService);
    }

    protected get baseUrl() {
        return `api/${this.entityName}`
    }
    private get httpTranslations() {
        return this.injector.get(HttpTranslations);
    }

    pagedQuery(model?: TQueryModel, options?: { showSpinning?: boolean }) {
        var httpParams = toHttpPararms(model);
        return this.httpClient.get<PagedResultModel<TModel>>(`${this.baseUrl}/pagedQuery`, {
            params: httpParams,
            ...options
        });

    }

    query(model?: TQueryModel, options?: { showSpinning?: boolean }) {
        var httpParams = toHttpPararms(model);
        return this.httpClient.get<PagedResultModel<TModel>>(`${this.baseUrl}/query`, {
            params: httpParams,
            ...options
        });


    }

    get(id: string, options?: { showSpinning?: boolean; }) {
        return this.httpClient.get<TModel>(`${this.baseUrl}/${id}`, {
            ...options
        });
    }

    getList(options: HttpRequestOptions = undefined) {
        options = {
            ...{
                showSpinning: true
            },
            ...options
        }
        var action$ = this.httpClient.get<TModel[]>(this.baseUrl);
        if (options.showSpinning) {
            action$ = this.spinningService.startWith(action$);
        }
        return action$;
    }

    create(model: TModel, options?: { showSpinning: boolean, notifyOnSuccess: boolean }) {

        var postOptins = {
            showSpinning: true,
            successMessage: this.httpTranslations.successfullySaved

        }
        if (options) {
            if (!options.showSpinning) {
                postOptins.showSpinning = false
            }
            if (!options.notifyOnSuccess) {
                delete postOptins.successMessage;
            }
        }
        return this.httpClient.post<TModel>(this.baseUrl, model, {
            ...postOptins
        });
    }

    _showMessage(key: string) {
        return this.translateService.get(`${httpConstants.translationGroup}.${key}`).pipe(
            tap(msg => this.messageService.success(msg))
        ).subscribe();
    }



    update(model: TModel, options?: { showSpinning: boolean, notifyOnSuccess: boolean }) {
        var putOptions = {
            showSpinning: true,
            successMessage: this.httpTranslations.successfullySaved

        }
        if (options) {
            if (!options.showSpinning) {
                putOptions.showSpinning = false
            }
            if (!options.notifyOnSuccess) {
                delete putOptions.successMessage;
            }
        }

        return this.httpClient.put<TModel>(this.baseUrl, model, {
            ...putOptions
        });
    }

    delete(id: string, options?: {
        showSpinning?: boolean;
        notifyOnSuccess?: boolean;
    }) {
        return this.httpClient.delete(`${this.baseUrl}/${id}`, {
            ...options,
            responseType: "arraybuffer"
        });
    }




}